import React from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import Theme from '../../theme';
import { TabBarLabel } from './TabBarLabel';
import { defaultScale } from '../../utils/scaling';

export const NavigationTabBarItem = ({
  isRouteActive,
  onPress,
  isLastRoute,
  icon,
  title,
  titleColour,
  customStyles = {
    containerStyle: {},
    innerStyle: {},
    labelStyle: {},
    iconContainerStyle: {}
  }
}) => {
  return (
    <TouchableOpacity
      style={[
        styles.tabButton,
        customStyles.containerStyle,
        isRouteActive && [styles.activeTab, { borderTopColor: Theme.PRIMARY }]]}
      onPress={onPress}>
      <View style={[styles.tabTopBar, isRouteActive && { backgroundColor: Theme.PRIMARY}]}/>
      <View style={[styles.innerTabButton, isLastRoute && { borderRightWidth: 0 }, customStyles.innerStyle]}>
        <View style={[styles.iconContainer, customStyles.iconContainerStyle]}>{icon}</View>
        <TabBarLabel color={titleColour} title={title} customLabelStyle={customStyles.labelStyle} />
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  tabButton: {
    flex: 1,
    paddingBottom: defaultScale(10),
    justifyContent: 'center',
    alignItems: 'center',
    borderTopWidth: 1,
    borderTopColor: Theme.GREY_LIGHT,
  },
  iconContainer: {
    justifyContent: 'center',
  },
  innerTabButton: {
    marginTop: defaultScale(10),
    flex: 1,
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRightWidth: defaultScale(2),
    borderRightColor: Theme.GREY_LIGHT,
  },
  tabTopBar: {
    height: defaultScale(2),
    width: '100%',
    backgroundColor: Theme.WHITE,
  },
  activeTab: {
    borderTopWidth: defaultScale(1),
    borderTopColor: Theme.PRIMARY,
  },
});
